let allIslands = [];
let visibleIslandNames = [];
let cachedFilteredAll = null;
let cachedFilteredVisible = null;

/**
 * Set islands from the API call
 * @param {Object} options
 * @param {Array} options.newIslands - All available islands
 * @param {Array} options.newVisibleIslands - Array of island names to show for non-admins (empty = show all)
 */
export function setIslands({ newIslands = [], newVisibleIslands = [] }) {
    allIslands = Array.isArray(newIslands) ? newIslands : [];
    visibleIslandNames = Array.isArray(newVisibleIslands) ? newVisibleIslands : [];
    // Clear caches
    cachedFilteredAll = null;
    cachedFilteredVisible = null;
}

/**
 * Get islands list
 * @param {boolean} includeNullTaxIsland - Include islands with vat=0
 * @param {boolean} isAdmin - If true, return all islands; if false, return only visible islands
 * @returns {[Array, boolean, boolean]} - [islands, loading, error]
 */
export function useIslands(includeNullTaxIsland = false, isAdmin = false) {
    // Determine base list: admins see all, non-admins see visible only (if configured)
    let baseList = allIslands;
    if (!isAdmin && visibleIslandNames.length > 0) {
        baseList = allIslands.filter(island => visibleIslandNames.includes(island.name));
    }

    // Filter out null tax islands if needed
    if (!includeNullTaxIsland) {
        // Use appropriate cache based on admin status
        if (isAdmin) {
            if (cachedFilteredAll === null) {
                cachedFilteredAll = allIslands.filter(island => island.vat !== 0);
            }
            return [cachedFilteredAll, false, false];
        } else if (visibleIslandNames.length > 0) {
            if (cachedFilteredVisible === null) {
                cachedFilteredVisible = baseList.filter(island => island.vat !== 0);
            }
            return [cachedFilteredVisible, false, false];
        } else {
            // No visible islands configured, use all islands cache
            if (cachedFilteredAll === null) {
                cachedFilteredAll = allIslands.filter(island => island.vat !== 0);
            }
            return [cachedFilteredAll, false, false];
        }
    }

    return [baseList, false, false];
}
